"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemStatus = void 0;
const getItemStatus = (item) => {
    if (item.status == "not_published" && item.draft.status == "changed")
        return "not_published_changed";
    return item.draft.status;
};
exports.getItemStatus = getItemStatus;
